<script>
	import { query, total_count } from "./stores";
	import OPTS from "./options"
	import SearchTerms from "./components/SearchTerms.svelte";
	import Tabs from "./components/Tabs.svelte"
	import Tab from "./components/Tab.svelte"
	import FacetFilter from "./components/FacetFilter.svelte";
	import FundFilter from "./components/FundFilter.svelte";
</script>

<main>
	<section class="top-page">
		<div class="container">
			<h2 class="title-page">{$total_count} risultati</h2>

            <SearchTerms />
		</div>
	</section>

	<section class="wrap-tab-results">
		<div class="container">
            <Tabs>
				{#if OPTS.mode_multi}
					{#each OPTS.archives as archive (archive.name)}
						<Tab tab_id={archive.name} type={archive.type} label={archive.label}>
							{#if archive.funds.length && archive.funds_field}
								<FundFilter funds={archive.funds} funds_field={archive.funds_field} />
							{/if}

							<div><label class="text-small">filtra per</label></div>

							{#each archive.filters as filter (filter)}
								<FacetFilter {...filter} />
							{/each}
						</Tab>
					{/each}
				{:else}
					<Tab tab_id="all" type={OPTS.archives[0].type} label="Tutti gli archivi" text={OPTS.tab_all_text || ''}>
						<div><label class="text-small">filtra per</label></div>

						{#each OPTS.archives[0].filters as filter (filter)}
							<FacetFilter {...filter} />
						{/each}
					</Tab>
					{#each OPTS.archives[0].funds as fund (fund.value)}
						<Tab tab_id={fund.value} root_id="{fund.root_id}" text={fund.description} type={OPTS.archives[0].type} label={fund.label}>
							<div><label class="text-small">filtra per</label></div>

							{#each OPTS.archives[0].filters as filter (filter)}
								<FacetFilter {...filter} />
							{/each}
						</Tab>
					{/each}
				{/if}
			</Tabs>
		</div>
	</section>
</main>

<style>
	ul.text-search li {
		display: inline;
		margin-right: 10px;
	}
</style>